import { createThunkAction } from "platopulse/lib/redux";

import PlatopulseAnalytics from "platopulse/lib/analytics";
import { PlatopulseApi } from "platopulse/services";

export const RESCAN_TABLE_VALUES = "platopulse/admin/tables/RESCAN_TABLE_VALUES";
export const DISCARD_TABLE_VALUES = "platopulse/admin/tables/DISCARD_TABLE_VALUES";

export const rescanTableFieldValues = createThunkAction(RESCAN_TABLE_VALUES, function(tableId) {
    return async function(dispatch, getState) {
        try {
            let call = await PlatopulseApi.table_rescan_values({tableId});
            PlatopulseAnalytics.trackEvent("Data Model", "Manual Re-scan Field Values for Table");
            return call;
        } catch(error) {
            console.log('error manually re-scanning field values', error);
        }
    };
});

export const discardTableFieldValues = createThunkAction(DISCARD_TABLE_VALUES, function(tableId) {
    return async function(dispatch, getState) {
        try {
            let call = await PlatopulseApi.table_discard_values({tableId});
            PlatopulseAnalytics.trackEvent("Data Model", "Manual Discard Field Values for Table");
            return call;
        } catch(error) {
            console.log('error discarding field values', error);
        }
    };
});



// WEBPACK FOOTER //
// ./admin/datamodel/table.js